import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  BrowserRouter as Router,
} from "react-router-dom";
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { store } from './main/redux/app/store';
import { Provider } from 'react-redux';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Inter',
      'Roboto', 'Helvetica', 'Arial', 'sans-serif'  // Default Roboto typography
    ].join(','),
  },
  /*palette: {
    primary: {
      main: '#6200ee',
    },
    secondary: {
      main: '#03dac6',
    },
  },*/
});

//console.log(theme);

ReactDOM.render(
  /*<React.StrictMode> react-table useRowSelect does not work in strict mode https://github.com/tannerlinsley/react-table/issues/2659 */
    <ThemeProvider theme={theme}>
      <Router>
        <Provider store={store}>
          <App />
        </Provider>
      </Router>
    </ThemeProvider>
  /*</React.StrictMode>*/,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
